import * as React from 'react';

import MaterialCostSource from 'ab-enums/materialCostSource.enum';

import MaterialRateSource from 'af-components/MaterialRateSource';

import styles from './styles.module.scss';

const TableLegend: React.FC = () => {
	return (
		<div className={styles.TableLegend}>
			<div className={styles.rateItem}>
				<MaterialRateSource className={styles.rateSource} rateSource={MaterialCostSource.COMPANY} /> Rates on company level
			</div>
			<div className={styles.rateItem}>
				<MaterialRateSource className={styles.rateSource} rateSource={MaterialCostSource.COMPANY_MATERIAL} /> Overrides on individual material level
			</div>
			<span className={styles.followingDayDisclaimer}>Any changes on rates are valid from the following day.</span>
		</div>
	);
};

export default React.memo(TableLegend);
